
import { getAiConversationsList } from '@/api/home/market';

const state = {
  conversationList: [],
  pagination: {
    page: 1,
  },
}
const mutations = {
  setConversationList(state, payload) {
    state.conversationList = payload;
  },
  setPagination(state, payload) {
    state.pagination = payload;
  }
}
const actions = {
  async getConversationsList({ commit, state }, val) {
    try {
      const params = {
        profile_id: this.state.user.currentId.profile_id,
        per_page: 25,
        page: 1,
        ...val,
      }
      const data = await getAiConversationsList(params);
      if (data) {
        let list = [];
        if (params.page === 1) {
          list = data.data.conversations;
        } else {
          list = [...state.conversationList, ...data.data.conversations]
        }
        commit('setConversationList', list);
        commit('setPagination', data.data.pagination);
        return {
          conversations: list,
          pagination: data.data.pagination,
        };
      }
    } catch (error) {

    }
  },

};

export default{
  namespaced: true,
  state,
  mutations,
  actions,
}
